import config from "@/config";
import router from "@/router";
import { validateCallbackUrl } from "@/data/repos/validateCallbackUrl";
import { getUserSession } from "@/data/repos/userInfo";

export function encodeParams(params: {
  [key: string]: string | undefined;
}): string {
  const pList = [] as string[];
  Object.keys(params)
    .filter((k) => params[k])
    .forEach((key) => {
      pList.push(`${key}=${encodeURIComponent(params[key] || "")}`);
    });
  return pList.join("&");
}

// TODO: remove client_id and user_id
export function redirectBackToTheClient(
  callbackUrl: string,
  params: { [key: string]: string | undefined }
) {
  params["return_uri"] = removeParamFromUrl(params["return_uri"], "cid");
  params["returnUrl"] = removeParamFromUrl(params["returnUrl"], "cid");

  const finalCallbackUrl = callbackUrl + "?" + encodeParams(params);
  if (decodeURI(callbackUrl).startsWith("/login-redirect")) {
    window.location.href = finalCallbackUrl;
    return;
  }
  validateRedirectURL(callbackUrl)
    .then(() => {
      window.location.href = finalCallbackUrl;
    })
    .catch((err) => {
      showError(`Incorrect callbackUrl: ${callbackUrl}`);
    });
}

function showError(err: string) {
  router.push({ name: "Error", query: { errorMessage: err } }).then();
}

export async function validateRedirectURL(url: string) {
  const resp = await validateCallbackUrl(url);
  if (resp.ok && resp.payload?.valid === true) return true;
  throw Error("Invalid callback URL");
}

function removeParamFromUrl(urlStr: string | undefined, param: string) {
  try {
    if (!urlStr) return urlStr;
    const urlObj = new URL(urlStr || "");
    const params = new URLSearchParams(urlObj.search);
    params.delete(param);
    urlObj.search = params.toString();
    return urlObj.href;
  } catch {
    console.warn("Could not parse URL", urlStr);
    return urlStr;
  }
}

export function switchClient(cid: string | undefined = undefined) {
  const returnUrl = new URL(window.location.href);
  returnUrl.search = "";
  window.location.href = router.resolve({
    name: "SwitchClient",
    query: {
      callbackUrl: config.AUTH_CALLBACK_URL,
      returnUrl: returnUrl.href || undefined,
      cid,
    },
  }).href;
}

export function redirectToPreLogin(query: any) {
  window.location.href = router.resolve({
    name: "pre-login",
    query: {
      ...query,
    },
  }).href;
}

export async function checkLicense(query: any) {
  const resp = await getUserSession(-1, query.app as string);
  if (
    resp.response &&
    resp.response.status === 403 &&
    resp.response.data.error === false
  ) {
    router
      .push({
        name: "LicenseError",
        query: {
          ...query,
          errorMessage: resp.response!.data.errorMessage,
        },
      })
      .then();
    return false;
  }
  return true;
}
